const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Carta di circolazione del veicolo',
	'vehicleRegistrationDocument.description':
		'Carica foto nitide dei lati richiesti della carta di circolazione.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Fronte della carta di circolazione',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Scatta una foto nitida del fronte della carta di circolazione.',
	'vehicleRegistrationDocument.RegistrationDocument.headline': 'Fronte della carta di circolazione',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Fronte della carta di circolazione - esempio',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Fronte della carta di circolazione',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Retro della carta di circolazione',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Scatta una foto nitida del retro della carta di circolazione.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Retro della carta di circolazione',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Retro della carta di circolazione - esempio',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Retro della carta di circolazione',
	'vehicleRegistrationDocument.validationHeadline': 'Foto mancanti',
	'vehicleRegistrationDocument.validationDescription': 'Aggiungi le seguenti foto:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Fotografa la carta di circolazione',
	'review.stepDescription.vehicleRegistrationDocument': 'Carta di circolazione del veicolo',

	'testcasemodal.headline': 'Avviso caso di test!',
	'testcasemodal.paragraph': 'Tieni presente che si tratta di un caso di test!',
	'testcasewarningalert.paragraph': 'Questo è un caso di test!',
	'testcasemodal.accept': 'Avanti',

	'loader.loading': 'Caricamento dati ...',
	'loader.error': 'Impossibile avviare il processo. Riprovare più tardi…',
	'connectionError.title': 'Errore di connessione',
	'connectionError.description':
		'Errore di connessione. Ti preghiamo di inviare nuovamente la foto.',
	'mainError.tryAgain': 'Prova di nuovo',
	'landing.headline.policyCheck': 'Ispezione del veicolo in pochi passi:',
	'landing.stepDescription.fourDiagonalPerspectives': 'Scatta le foto richieste',
	'landing.stepDescription.fourAdditionalPictures': 'Invia le foto',
	'landing.stepDescription.feedback': 'Dacci il tuo feedback',
	'landing.termsAndConditionsLinkDescription':
		'Per iniziare, accetta i termini e le condizioni di utilizzo e premi Avanti.',
	'landing.termsAndConditionsLink': 'Accetta i termini e le condizioni di utilizzo',
	'landing.paragraph': ' ',
	'button.start': 'Avanti',
	'button.close': 'Chiudi',
	'landing.aboutPolicyCheck': "Cos'è PolicyCheck?",
	'tutorialModal.headline.first.policyCheck': "Cosa c'è dietro PolicyCheck?",
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck è una rapida ispezione del veicolo. Il processo di ispezione si compone di 8 semplici passi.',
	'chooseLang.headline': 'Scegli la tua lingua preferita',
	'vehicleImages.overviewPhotos': 'Foto panoramiche del veicolo',

	'additionaldamagewarningalert.paragraph':
		'La nostra intelligenza artificiale ha rilevato possibili danni nelle immagini, si prega di notare che queste saranno esaminate da uno dei nostri esperti.',

	'vehicleImages.overviewPhotos.subtitle': 'Fotografa il veicolo',
	'vehicleImages.description': 'TI preghiamo di scattare le foto come indicato.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Foto del lato anteriore sinistro del veicolo',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Foto del lato posteriore sinistro del veicolo',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Foto del lato posteriore destro del veicolo',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Foto del lato anteriore destro del veicolo',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Foto di esempio',

	'imageRecognitionMismatchModal.headline': 'Sei sicuro di aver aggiunto la foto corretta?',
	'button.continue': 'Avanti',
	'button.next': 'Avanti',
	'button.prev': 'Indietro',
	'button.backchangeImage': 'Torna indietro e cambia foto',

	'fourPerspectivesExampleModal.headline.first': 'Foto di esempio',
	'fourPerspectivesExampleModal.button.close': 'Chiudi',

	'vehicleImages.leftFrontOverview': 'Foto diagonale del lato anteriore sinistro',
	'vehicleImages.rightFrontOverview': 'Foto diagonale del lato anteriore destro',
	'vehicleImages.leftRearOverview': 'Foto diagonale del lato posteriore sinistro',
	'vehicleImages.rightRearOverview': 'Foto diagonale del lato posteriore destro',
	'button.changeImage': 'Cambia la foto',
	'button.deleteImage': 'Elimina la foto',

	'completeVehicleImagesModal.headline': 'Suggerimento',
	'completeVehicleImagesModal.description': 'TI preghiamo di aggiungere le seguenti informazioni',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft':
		'Foto del lato anteriore sinistro del veicolo',
	'completeVehicleImagesModal.hasVehicleImageRearRight':
		'Foto del lato posteriore destro del veicolo',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Foto del lato anteriore destro del veicolo',
	'completeVehicleImagesModal.hasVehicleImageRearLeft':
		'Foto del lato posteriore sinistro del veicolo',

	'fourAdditionalPictures.title': 'Foto aggiuntive',
	'fourAdditionalPictures.overallDashboard.title': 'Cruscotto del veicolo',
	'fourAdditionalPictures.overallDashboard.description':
		'Inquadra completamente il cruscotto del veicolo.',
	'fourAdditionalPictures.mileage.title': 'Chilometraggio',
	'fourAdditionalPictures.mileage.description':
		'Scatta una foto del contachilometri. Se il tuo veicolo ha un display digitale ricordati di accenderlo.',
	'dashboardMileage.dashboard.paragraph':
		'Scatta una foto del contachilometri. Se il tuo veicolo ha un display digitale ricordati di accenderlo.',
	'fourAdditionalPictures.mileage.enter': 'Inserisci il chilometraggio del veicolo',
	'dashboardMileage.paragraph.first': 'Inserisci il chilometraggio del veicolo',
	'dashboardMileage.placeholder': 'ad esempio 150000 km',
	'fourAdditionalPictures.windshield.description':
		'Scata una foto dettagliata del parabrezza anteriore del veicolo',

	'fourAdditionalPictures.vin.description':
		"Scatta una foto del numero di telaio del veicolo. Puoi trovarlo sulla guarnizione della portiera lato guida o nell'angolo in basso a sinistra del parabrezza.",

	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Foto di esempio',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Foto di esempio',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Foto di esempio',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Foto di esempio',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Foto di esempio',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Foto di esempio',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Foto di esempio',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Foto di esempio',

	'overallDashboardImage.title': 'Foto complessiva del cruscotto',
	'dashboardMileage.dashboard.title': 'Foto del contachilometri',
	'fourAdditionalPictures.windshield.title': 'Foto del parabrezza',
	'fourAdditionalPictures.vin.title': 'Numero di telaio del veicolo',
	'overallDashboardImage.headline': 'Foto complessiva del cruscotto',
	'dashboardMileage.dashboard.headline': 'Foto del contachilometri',
	'windshieldImage.headline': 'Foto del parabrezza',
	'vinPicture.headline': 'Foto del numero di telaio',

	'completeFourAdditionalPicturesModal.headline': 'Suggerimento',
	'completeFourAdditionalPicturesModal.description':
		'Ti preghiamo di aggiungere le seguenti informazioni',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Foto del cruscotto del veicolo',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Foto del contachilometri',
	'completeDashboardMileageModal.hasValidMileage': 'Chilometraggio del veicolo',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Foto del numero di telaio del veicolo',
	'completeFourAdditionalPicturesModal.hasWindshieldImage':
		'Foto del parabrezza anteriore del veicolo',
	'button.ok': 'Ok',

	'fourAdditionalPicturesExampleModal.button.close': 'Chiudi',

	'feedback.headline.policyCheck': 'Grazie per aver utilizzato PolicyCheck!',
	'feedback.description':
		'Speriamo che il nostro servizio ti abbia soddisfatto e attendiamo il tuo prezioso feedback.',
	'feedback.rating.policyCheck': "Come valuti l'ispezione del veicolo con PolicyCheck?",
	'feedback.yourOpinion': 'La tua valutazione',
	'feedback.button.send': 'Invia la valutazione',

	'thanks.headline.first': 'Grazie!',
	'waitForAudit.thankYou': 'Grazie!',
	'waitForAudit.description.damageFound':
		"Il passo successivo spetta a noi. Ti informeremo sull'esito dell'ispezione telefonicamente o via e-mail.",
	'thanks.paragraph.first':
		"Il passo successivo spetta a noi. Ti informeremo sull'esito dell'ispezione telefonicamente o via e-mail.",

	'editPhoto.edit': 'Modifica',

	'invalidFile.size.title': 'Dimensione foto non valid',
	'invalidFile.size.description': 'Le dimensioni della foto sono maggiori del massimo richiesto',
	'invalidFile.extension.title': 'Tipo di file non supportato',
	'invalidFile.extension.description':
		'Il file selezionato è di un tipo non supportato. I tipi supportati sono: .jpg, .jpeg, .jfif, .heic, .heif, .png e .bmp',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
